  document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.p-legacy-hero__video-container');
    if (!container) return;
    const poster = container.querySelector('.js-video-poster');
    const playBtn = container.querySelector('.js-video-play');
    const html5Video = container.querySelector('.js-html5-video');
    const youtube = container.querySelector('.js-youtube');
    const vimeo = container.querySelector('.js-vimeo');

    if (!playBtn) return;

    playBtn.addEventListener('click', () => {
      if (poster) poster.style.display = 'none';

      if (html5Video) html5Video.play();

      if (youtube) {
        let src = youtube.src;
        if (!src.includes('autoplay=1')) {
          youtube.src = src + (src.includes('?') ? '&autoplay=1' : '?autoplay=1');
          if (!src.includes('loop=1')) {
            youtube.src += '&loop=1&playlist={{ video_id }}';
          }
        }
      }

      if (vimeo) {
        let src = vimeo.src;
        if (!src.includes('autoplay=1')) {
          vimeo.src = src + (src.includes('?') ? '&autoplay=1' : '?autoplay=1');
          if (!src.includes('loop=1')) {
            vimeo.src += '&loop=1';
          }
        }
      }
    });
  });